// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TravelCreditCardRouteImport } from './routes/travel-credit-card'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as IndexRouteImport } from './routes/index'
import { Route as IxiFinanceIndexRouteImport } from './routes/ixi-finance.index'
import { Route as TravelCreditCardManageRouteImport } from './routes/travel-credit-card_.manage'
import { Route as TravelCreditCardComparisonRouteImport } from './routes/travel-credit-card_.comparison'
import { Route as TravelCreditCardApplyRouteImport } from './routes/travel-credit-card_.apply'
import { Route as IxiFinanceTransactionHistoryRouteImport } from './routes/ixi-finance.transaction-history'
import { Route as AuthIxiFinanceManagePaymentsRouteImport } from './routes/_auth.ixi-finance.manage-payments'

const TravelCreditCardRoute = TravelCreditCardRouteImport.update({
            id: '/travel-credit-card',path: '/travel-credit-card',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/_auth',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const IxiFinanceIndexRoute = IxiFinanceIndexRouteImport.update({
            id: '/ixi-finance/',path: '/ixi-finance/',getParentRoute: () => rootRouteImport
          })
const TravelCreditCardManageRoute = TravelCreditCardManageRouteImport.update({
            id: '/travel-credit-card_/manage',path: '/travel-credit-card/manage',getParentRoute: () => rootRouteImport
          })
const TravelCreditCardComparisonRoute = TravelCreditCardComparisonRouteImport.update({
            id: '/travel-credit-card_/comparison',path: '/travel-credit-card/comparison',getParentRoute: () => rootRouteImport
          })
const TravelCreditCardApplyRoute = TravelCreditCardApplyRouteImport.update({
            id: '/travel-credit-card_/apply',path: '/travel-credit-card/apply',getParentRoute: () => rootRouteImport
          })
const IxiFinanceTransactionHistoryRoute = IxiFinanceTransactionHistoryRouteImport.update({
            id: '/ixi-finance/transaction-history',path: '/ixi-finance/transaction-history',getParentRoute: () => rootRouteImport
          })
const AuthIxiFinanceManagePaymentsRoute = AuthIxiFinanceManagePaymentsRouteImport.update({
            id: '/ixi-finance/manage-payments',path: '/ixi-finance/manage-payments',getParentRoute: () => AuthRoute
          })





const AuthRouteChildren = {
  AuthIxiFinanceManagePaymentsRoute: AuthIxiFinanceManagePaymentsRoute
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthRoute: AuthRouteWithChildren,TravelCreditCardRoute: TravelCreditCardRoute,IxiFinanceTransactionHistoryRoute: IxiFinanceTransactionHistoryRoute,TravelCreditCardApplyRoute: TravelCreditCardApplyRoute,TravelCreditCardComparisonRoute: TravelCreditCardComparisonRoute,TravelCreditCardManageRoute: TravelCreditCardManageRoute,IxiFinanceIndexRoute: IxiFinanceIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)